import { effects as fx, SagaIterator } from 'redux-saga';

import * as CartSaga from './cart';
import * as CheckoutSaga from './checkout';
import * as CountriesSaga from './countries';
import * as LocalStorageSaga from './localStorage';
import * as PardotSaga from './pardot';
import * as PlayerSaga from './player';
import * as PostAuthenticationRequests from './postAuthenticationRequests';
import * as PreferencesSaga from './preferences';
import * as ProjectsSaga from './projects';
import * as UserSaga from './user';

export default function* rootSaga(): SagaIterator {
  yield fx.all([
    fx.call(CartSaga.init),
    fx.call(CheckoutSaga.init),
    fx.call(CountriesSaga.init),
    fx.call(LocalStorageSaga.init),
    fx.call(PostAuthenticationRequests.init),
    fx.call(PreferencesSaga.init),
    fx.call(ProjectsSaga.init),
    fx.call(UserSaga.init),
    fx.call(PardotSaga.init),
    fx.call(PlayerSaga.init),
  ]);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/sagas/index.ts